export const USER_NOT_CHECKED = Symbol('User not checked');
